import { axiosApi } from './axios.api';

const url = `/api/provinces`;

export const getProvincesApi = async () => {
  try {
    const response = await axiosApi.get(url);
    return response.data;

  } catch (e: any) {
    throw new Error(e);
  }
};


export const getDistrictsApi = async (provinceCode: string) => {
  try {
    const response = await axiosApi.get(`${url}/${provinceCode}/districts`);
    return response.data;

  } catch (e: any) {
    throw new Error(e);
  }
};


export const getWardsApi = async (provinceCode: string, districtCode: string) => {
  try {
    const response = await axiosApi.get(`${url}/${provinceCode}/districts/${districtCode}/wards`);
    return response.data;

  } catch (e: any) {
    throw new Error(e);
  }
};
